import { isApiError } from '@multaqa/api-client'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AppShell } from '@/components/app-shell'
import { currentUserQuery } from '@/lib/auth'

/**
 * Pathless layout route enforcing the session.
 *
 * Everything nested under `_authenticated/` is behind this guard, so a new
 * screen is protected by where its file sits rather than by remembering to add
 * a check. `beforeLoad` runs before the component, so an unauthenticated
 * visitor never renders a frame of the shell.
 *
 * This is a UX guard, not a security boundary. The API authorises every request
 * independently; a user who defeats this sees an empty shell and 401s.
 */
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(currentUserQuery)
    } catch (error) {
      if (isApiError(error) && error.status === 401) {
        throw redirect({
          to: '/login',
          search: { redirect: location.href },
        })
      }
      throw error
    }
  },

  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
})
